import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import { Col, Row, Button } from 'react-bootstrap'

import { useDispatch, useSelector } from 'react-redux'
import { upsertIntegration } from 'api/integrations'
import { IntegrationTypes } from 'models/integrations'
import Loader from 'components/ui/loader/Loader'
import { Actions } from 'store/actions/general.action'
import { IMainState } from 'store/states'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import useIntegrations from 'hooks/useIntegrations'
import { Sence } from './Sence'
import { FormValues, schema } from './constants'

export const Integrations = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { loading } = useSelector(
    ({ general }: IMainState) => general.integrations
  )
  const senceForm = useForm<FormValues>({
    // @ts-ignore
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: { senceState: false, sence: { token: '', runOtec: '' } },
  })

  useEffect(() => {
    dispatch(Actions.getIntegrationsList())
  }, [dispatch, senceForm])

  const { integrationSence } = useIntegrations()

  useEffect(() => {
    if (IntegrationTypes.sence === integrationSence?.integrationType) {
      const { config } = { ...integrationSence }
      senceForm.setValue('sence', {
        token: config?.token || '',
        runOtec: config?.runOtec || '',
      })
      senceForm.setValue('senceState', !!integrationSence?.active)
    }
  }, [integrationSence, senceForm])

  const onSubmit = async ({ sence, senceState }: FormValues) => {
    try {
      await upsertIntegration({
        integrationType: IntegrationTypes.sence,
        active: senceState,
        config: sence && {
          runOtec: sence.runOtec,
          token: sence.token,
        },
      })
      SuccessToast(t('administration.toastMessages.editSuccess'))
    } catch {
      ErrorToast(t('administration.toastMessages.editError'))
    }
  }

  const {
    formState: { isValid },
  } = senceForm

  return (
    <>
      <Row>
        <Col xs={12}>{loading && <Loader />}</Col>
        {!loading && integrationSence?.active && (
          <Col xs={12}>
            <Sence {...{ form: senceForm }} />
            <Row className="mx-xs-1 mx-md-5 justify-content-center">
              <Col xs={12} md={6} lg={2}>
                <Button
                  size="sm"
                  className="mt-1 w-100"
                  disabled={!isValid}
                  onClick={senceForm.handleSubmit(onSubmit)}
                >
                  {t('commons.buttons.save')}
                </Button>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </>
  )
}
